import { PlanTierEnum } from "@/interFace/courses/types";

export const CLASSROOM_PLAN_STANDARD_ID = "classroom-plan-standard";
export const CLASSROOM_PLAN_PREMIUM_ID = "classroom-plan-premium";

export const CLASSROOM_PLAN_IDS = new Set<string>([
  CLASSROOM_PLAN_STANDARD_ID,
  CLASSROOM_PLAN_PREMIUM_ID,
]);

export const isClassroomPlanId = (productId: string | null | undefined): boolean => {
  if (!productId) {
    return false;
  }

  return CLASSROOM_PLAN_IDS.has(productId);
};

export const hasPaidClassroomPlan = (accountTypeId: number | null | undefined): boolean => {
  return typeof accountTypeId === "number" && accountTypeId >= PlanTierEnum.Standard;
};